import React, { Component } from 'react';
import {
    Menu, Dropdown, Icon, Button,
} from 'antd';
import DashboardContainer from '../containers/DashboardContainer';
import InfoHome from './InfoHome';
import { base } from '../../base';
import constants from '../../constants';

import './Home.css';

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            companies: [],
            company: null,
        };
        this.handleMenuClick = this.handleMenuClick.bind(this);
    }

    componentDidMount() {
        this.valuesRef = base.syncState('companies', {
            context: this,
            state: 'companies',
            asArray: true,
        });
    }

    handleMenuClick(e) {
        console.log('click', e);
        const { companies } = this.state;
        const c = companies[e.item.props.index];
        this.setState({
            company: c,
        });
    }

    render() {
        console.log(this.props.authenticated);
        if (this.props.authenticated === true) {
            const { companies } = this.state;
            let { company } = this.state;
            if (company == null && companies.length > 1) {
                company = companies[0];
            }
            let companyid = this.props.extraUser.companyid;
            if (company != null && this.props.extraUser.type === constants.SADMIN_ROLE) {
                companyid = company.key;
                this.props.extraUser.companyid = companyid;
            }
            const menuItems = this.state.companies.map(ele => (
                <Menu.Item key={ele.key}>
                    {ele.name}
                </Menu.Item>
            ));
            const menu = (
                <Menu onClick={this.handleMenuClick}>
                    {menuItems}
                </Menu>
            );
            return (
                <div>
                    { this.props.extraUser.type === constants.SADMIN_ROLE && (
                        <Dropdown overlay={menu}>
                            <Button style={{ marginLeft: 8 }}>
                                { company != null && company.name }
                                <Icon type="down" />
                            </Button>
                        </Dropdown>
                    )}
                    <DashboardContainer
                        companyid={companyid}
                        company={company}
                        user={this.props.currentUser}
                        extraUser={this.props.extraUser}
                    />
                </div>
            );
        } else {
            return (
                <InfoHome />
            );
        }
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/views/Home.js